import { createReducer, on } from '@ngrx/store';
import { loginSuccess, logout } from '../actions/store-action';
import { AuthState, initialAuthState } from '../state/store-model';

export const authReducer = createReducer(
  initialAuthState,
  on(loginSuccess, (state, { user }) => ({ ...state, user })),
  on(logout, state => ({ ...state, user: null }))
);
